import React from 'react';
import { Box } from '@chakra-ui/react';

import DataTypes from '../../../../../../../../../../../constants/dataTypes';

const PropertyCell = ({ value, dataType }) => {
  if (value === null || value === undefined || value === 'null') return null;

  return (
    <Box
      textAlign="center"
      whiteSpace={dataType === DataTypes.DateTime ? 'nowrap' : 'initial'}
    >
      {value}
    </Box>
  );
};

export default PropertyCell;
